<div class="dashboard-container" *ngIf="showData">
    <div *ngIf="showErrors" class="alert valign-children-middle">
        <div class="alert-error" role="img" aria-label="Error">
            <i class="icon-badgealert"></i>
        </div>
        <div>
            <span>{{errorMessage}}</span>
        </div>
    </div>

    <form [formGroup]="dashBoardForm" (ngSubmit)="next()" autocomplete="off">
        <section>
        <div class="form-group" >
            <h1>Customer data</h1>
            <h2>Welcome, {{agentProfileData.agentName}}</h2>
            <h3>Current customer data</h3>
            <section class="detailsHolder">
               <div>
                  <label>
                     <span class="paraLabel">Customer account number</span>
                       <p class="divider" > {{agentSingleFan}} <span *ngIf="agentProfileData.showEdit">&nbsp;&nbsp;| </span><a *ngIf="agentProfileData.showEdit" class="disabled" class="btn btn-link" (click)="editMessage()"> edit</a></p>
                  </label >
               </div> 
           </section>
             <section class="detailsHolder">
               <div>
                  <label>
                     <span class="paraLabel"><p>Customer Name</p></span>
                       <p class="divider" > {{agentProfileData.customerName}} </p>
                  </label >
               </div> 
           </section>
           <section *ngFor="let element of pageJson">
            <div *ngIf="element.inputType === 'text'" class="check">                
                <div *ngFor="let inputText of element.textBox">                     
                    <label for="{{element.formControlName+inputText.label}}">
                        <p>{{inputText.label}}</p>
                        <input type="text" formControlName="{{inputText.formControlName}}"  class="form-control textbox" 
                        [placeholder]="inputText.placeholder" id="{{element.formControlName+inputText.label}}" required/>
                    </label>
                </div>
            </div>
            <div *ngIf="element.inputType === 'radio'" class="check"> 
                <h4>Launch mode</h4>
                <div *ngFor="let option of element.option" class="radio">                     
                    <label for="{{element.formControlName+option.label}}">
                        <input type="radio" formControlName="{{option.formControlName}}" id="{{element.formControlName + option.label}}" 
                            [checked]="option.value === customerLaunchmode" (click)="setOptionValue(option.value)" value="{{option.value}}">
                        <i class="skin"></i>
                        <span class="formSpan">{{option.label}}</span>
                        <span class="formSpan">{{option.note}}</span>
                    </label>
                </div>
            </div>
           </section>
        </div>
        <div class="cta text-left">
            <button class="btn btn-secondary col-md-3 col-sm-12" type="submit" [disabled]="dashBoardForm.invalid">Continue</button>
        </div>
        </section>
    </form>
</div>